import React from "react";
import { Link } from "react-router-dom";
import { Compass, Home, Plane, MessageCircle } from "lucide-react";
import { waLink } from "@/lib/api";
import { usePageMeta, useNoIndex } from "@/lib/seo";

export default function NotFound() {
  usePageMeta("Page Not Found", "The page you are looking for could not be found. Explore flights, visas, hotels and holiday packages with Makchester Tours & Travel.");
  useNoIndex();
  return (
    <div className="bg-[#0A2E4D] min-h-[70vh] flex items-center justify-center py-24" data-testid="not-found-page">
      <div className="max-w-xl mx-auto px-6 text-center">
        <Compass size={52} className="text-[#E3BA45] mx-auto mb-6" strokeWidth={1.2} />
        <div className="font-serif-display text-7xl text-white">404</div>
        <h1 className="font-serif-display text-2xl sm:text-3xl text-white mt-4">This destination doesn't exist</h1>
        <p className="text-slate-300 text-sm mt-4 leading-relaxed">The page you're looking for may have moved or never existed — but the world is still waiting. Let's get you back on route.</p>
        <div className="flex flex-wrap justify-center gap-3 mt-8">
          <Link to="/" className="inline-flex items-center gap-2 bg-[#E3BA45] hover:bg-[#D4A62A] text-[#0A2E4D] px-6 py-3 rounded-full text-sm font-semibold transition-colors" data-testid="notfound-home-btn">
            <Home size={15} /> Back to Home
          </Link>
          <Link to="/flights" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-6 py-3 rounded-full text-sm font-semibold transition-colors" data-testid="notfound-flights-btn">
            <Plane size={15} /> Flight Enquiry
          </Link>
          <a href={waLink("Hello Makchester Tours & Travel, I need help finding something on your website.")} target="_blank" rel="noreferrer"
             className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white px-6 py-3 rounded-full text-sm font-semibold transition-colors" data-testid="notfound-whatsapp-btn">
            <MessageCircle size={15} /> WhatsApp Us
          </a>
        </div>
      </div>
    </div>
  );
}
